export const localConstants = {
    CHANGE_LOCALE_LANGUAGE_SUCCESS: 'CHANGE_LOCALE_LANGUAGE_SUCCESS',
};


